module.exports = __webpack_public_path__ + "img/955947730.ec6c45f8.jpg";